
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/miro-to-figjam",
      function () {
        return require("private-next-pages/converter/miro-to-figjam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/miro-to-figjam"])
      });
    }
  